/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: 3naiwkyPoFj

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import PriceTierChip from "../../components/pricing/PriceTierChip"; // plasmic-import: UwHbCO-1rFrq/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicTeamPickerItem.module.css"; // plasmic-import: 3naiwkyPoFj/css

import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon

createPlasmicElementProxy;

export type PlasmicTeamPickerItem__VariantMembers = {};
export type PlasmicTeamPickerItem__VariantsArgs = {};
type VariantPropType = keyof PlasmicTeamPickerItem__VariantsArgs;
export const PlasmicTeamPickerItem__VariantProps = new Array<VariantPropType>();

export type PlasmicTeamPickerItem__ArgsType = { teamName?: React.ReactNode };
type ArgPropType = keyof PlasmicTeamPickerItem__ArgsType;
export const PlasmicTeamPickerItem__ArgProps = new Array<ArgPropType>(
  "teamName"
);

export type PlasmicTeamPickerItem__OverridesType = {
  root?: Flex__<"div">;
  newPriceTierChip?: Flex__<typeof PriceTierChip>;
  text?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultTeamPickerItemProps {
  teamName?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicTeamPickerItem__RenderFunc(props: {
  variants: PlasmicTeamPickerItem__VariantsArgs;
  args: PlasmicTeamPickerItem__ArgsType;
  overrides: PlasmicTeamPickerItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox___2SOfh)}>
        {renderPlasmicSlot({
          defaultContents: "Team Name",
          value: args.teamName,
          className: classNames(sty.slotTargetTeamName),
        })}
        <div className={classNames("all", sty.freeBox__yYwPl)}>
          <PriceTierChip
            data-plasmic-name={"newPriceTierChip"}
            data-plasmic-override={overrides.newPriceTierChip}
            className={classNames("__wab_instance", sty.newPriceTierChip)}
            simplified={true}
            tier={
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames("all", "__wab_text", sty.text)}
              >
                {"Free"}
              </div>
            }
          />

          <ArrowRightSvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames("all", sty.svg)}
            role={"img"}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "newPriceTierChip", "text", "svg"],
  newPriceTierChip: ["newPriceTierChip", "text"],
  text: ["text"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  newPriceTierChip: typeof PriceTierChip;
  text: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTeamPickerItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTeamPickerItem__VariantsArgs;
    args?: PlasmicTeamPickerItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicTeamPickerItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTeamPickerItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTeamPickerItem__ArgProps,
          internalVariantPropNames: PlasmicTeamPickerItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicTeamPickerItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTeamPickerItem";
  } else {
    func.displayName = `PlasmicTeamPickerItem.${nodeName}`;
  }
  return func;
}

export const PlasmicTeamPickerItem = Object.assign(
  // Top-level PlasmicTeamPickerItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    newPriceTierChip: makeNodeComponent("newPriceTierChip"),
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicTeamPickerItem
    internalVariantProps: PlasmicTeamPickerItem__VariantProps,
    internalArgProps: PlasmicTeamPickerItem__ArgProps,
  }
);

export default PlasmicTeamPickerItem;
/* prettier-ignore-end */
